import type { EchoOptions } from 'laravel-echo'

type EchoConfigResult =
  | {
    config: EchoOptions<'reverb'>
  }
  | {
    config: EchoOptions<'null'>
    warning: string
  }

function hasValue(value?: string): value is string {
  return typeof value === 'string' && value.trim() !== ''
}

export function createEchoConfig(env: ImportMetaEnv): EchoConfigResult {
  const key = env.VITE_REVERB_APP_KEY
  const host = env.VITE_REVERB_HOST
  const portValue = env.VITE_REVERB_PORT
  const scheme = env.VITE_REVERB_SCHEME ?? 'https'

  const missingKeys = [
    !hasValue(key) ? 'VITE_REVERB_APP_KEY' : null,
    !hasValue(host) ? 'VITE_REVERB_HOST' : null,
    !hasValue(portValue) ? 'VITE_REVERB_PORT' : null,
  ].filter((value): value is string => value !== null)

  if (missingKeys.length > 0) {
    return {
      config: { broadcaster: 'null' },
      warning: `Echo disabled: missing ${missingKeys.join(', ')}.`,
    }
  }

  const port = Number(portValue)

  if (!Number.isFinite(port)) {
    return {
      config: { broadcaster: 'null' },
      warning: 'Echo disabled: VITE_REVERB_PORT must be numeric.',
    }
  }

  return {
    config: {
      broadcaster: 'reverb',
      key,
      wsHost: host,
      wsPort: port,
      wssPort: port,
      forceTLS: scheme === 'https',
      enabledTransports: ['ws', 'wss'],
    },
  }
}
